import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private _config: {};

  constructor(private http: HttpClient) {
  }

  /**
   * Load configuration from a file
   */
  load(fileUrl: string): Promise<{}> {
    return this.http.get<{}>(fileUrl)
      .toPromise()
      .then(data => {
        this._config = data;
        return this._config;
      });
  }

  get config(): {} {
    return this._config;
  }

  get(name: string, def?: any): any {
    if (this._config.hasOwnProperty(name)) {
      return this._config[name];
    }
    return def;
  }

  apiUrl(...path: string[]): string {
    return this.get('apiEndpoint', '') + path.join('/');
  }

  apiVerUrl(...path: string[]): string {
    return this.get('apiEndpoint', '') + '/' + this.get('apiVersion', '') + path.join('/');
  }
}
